export const ActionType={
    Undefined: 0,
    FirstHint: 1,
    GiveHint: 2,
    Guess: 3,
    ConfirmGuess: 4,
    Finished: 5
}

export const GameFinishStatus={
    None: 0,
    Success: 1,
    TimeRanOut: 2,
    Assassinated: 3
}

export const CellType={
    None: 0,
    Green: 1,
    Yellow: 2,
    Black: 3
}

export const GameSessionState = {
    Lobby: 0,
    Game: 1,
    Abandoned: 2
}